import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CHANGE_HISTORY_SLICE_NAME } from './constants';
import { TChangeHistoryStore, TChangeHistoryRequest, TChangeHistoryResponsePayload } from './types';

const initialState: TChangeHistoryStore = {
	changeHistory: null,
	changeHistoryLoading: false,
	changeHistoryByEm: null,
	changeHistoryByEmLoading: false,
	changeHistoryByUser: null,
	changeHistoryByUserLoading: false,
};

const changeHistory = createSlice({
	name: CHANGE_HISTORY_SLICE_NAME,
	initialState,
	reducers: {
		getChangeHistoryRequest: (
			state: TChangeHistoryStore,
			_action: PayloadAction<TChangeHistoryRequest>,
		) => {
			const nextState = state;
			nextState.changeHistoryLoading = true;
		},
		getChangeHistorySuccess: (
			state: TChangeHistoryStore,
			action: PayloadAction<TChangeHistoryResponsePayload>,
		) => {
			const { payload } = action;
			const nextState = state;
			nextState.changeHistory = payload;
			nextState.changeHistoryLoading = false;
		},
		getChangeHistoryByEmRequest: (
			state: TChangeHistoryStore,
			_action: PayloadAction<{ id: number; body: TChangeHistoryRequest }>,
		) => {
			console.log('getChangeHistoryByEmRequest');
			const nextState = state;
			nextState.changeHistoryByEmLoading = true;
		},
		getChangeHistoryByEmSuccess: (
			state: TChangeHistoryStore,
			action: PayloadAction<TChangeHistoryResponsePayload>,
		) => {
			const { payload } = action;
			const nextState = state;
			nextState.changeHistoryByEm = payload;
			nextState.changeHistoryByEmLoading = false;
		},
		getChangeHistoryByUserRequest: (
			state: TChangeHistoryStore,
			_action: PayloadAction<{ userId: string; body: TChangeHistoryRequest }>,
		) => {
			const nextState = state;
			nextState.changeHistoryByUserLoading = true;
		},
		getChangeHistoryByUserSuccess: (
			state: TChangeHistoryStore,
			action: PayloadAction<TChangeHistoryResponsePayload>,
		) => {
			const { payload } = action;
			const nextState = state;
			nextState.changeHistoryByUser = payload;
			nextState.changeHistoryByUserLoading = false;
		},
		changeHistoryInitState: () => initialState,
	},
});

export const {
	getChangeHistoryRequest,
	getChangeHistorySuccess,
	getChangeHistoryByEmRequest,
	getChangeHistoryByEmSuccess,
	getChangeHistoryByUserRequest,
	getChangeHistoryByUserSuccess,
	changeHistoryInitState,
} = changeHistory.actions;

export default changeHistory.reducer;
